<template>
  <div class="row selectVideo pr-3">
    <div class="col-lg-12 mt-4 col-xs-12">
      <div class="form-group mb-0 has-search">
        <span class="fa fa-search ml-2 mt-2 form-control-feedback"></span>
        <input
          type="text"
          v-model="search"
          v-on:keyup.enter="searchVideos"
          class="form-control no_border bg_grey"
          placeholder="Search"
        />
      </div>
    </div>
    <div class="col-lg-6 pl-4 pr-4 pt-2 col-xs-12">
      <div class="container-video">
        <span v-if="videos.length == 0">NÃO HÁ VÍDEOS</span>
        <div class="row mr-0 ml-0">
          <div
            v-for="(video, index) in videos"
            :key="video.id"
            class="mt-2 mb-2 col-lg-6 col-xs-12"
          >
            <div
              :class="{ selected_video: index == select ? true : false }"
              class="pointer"
              @click="videoCurrent(index)"
            >
              <img :src="video.thumbnail" class="full" />
              <div>
                <p class="crop_text overflow align-left f12 mt-0 mb-0">
                  {{ video.name }}
                </p>
                <p
                  class="crop_text overflow align-left name_recruiter mt-0 mb-0"
                >
                  {{ video.recruiter_name }}
                </p>
                <p class="align-left name_recruiter f9 mt-0 mb-0">
                  {{ video.created_at | moment("D/MM/Y") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-xs-12">
      <div v-if="videos.length != 0">
        <h2 class="crop_text overflow">{{ videos[select].name }}</h2>
        <video
          style="margin: 0px auto"
          id="video_current"
          v-if="videos.length != 0"
          controls
          controlslist="nodownload"
          class="full"
        >
          <source :src="videos[select].video" />
        </video>
      </div>
    </div>
    <div class="col-lg-12 col-xs-12">
      <button @click="chooseVideo" class="btn btn-primary full">
        SELECIONAR VÍDEO
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reference_id", "category_id", "close"],
  data: () => ({
    src_selected: "",
    search: "",
    videos: [],
    select: 0,
  }),
  mounted() {
    this.searchVideos();
  },
  methods: {
    videoCurrent(index) {
      if (this.videos.length) {
        this.select = index;
        let video = document.getElementById("video_current");
        video.load();
      }
    },
    searchVideos() {
      let params = {
        search: this.search == "" ? "*" : this.search,
      };
      axios
        .get("/recruiters/gallery_videos", { params: params })
        .then((response) => {
          this.videos = response.data.videos;
          this.videoCurrent(0);
        });
    },
    chooseVideo() {
      // this.$modal.hide("selectVideoGalleryItem");
      eventBus.$emit("chooseVideo", {
        video_id: this.videos[this.select].id,
        video: this.videos[this.select].video,
        name: this.videos[this.select].name,
      });
    },
  },
};
</script>